import * as React from "react";
const SvgEvents = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M3 19.5C3 20.3288 3.672 21 4.5 21H19.5C20.3288 21 21 20.328 21 19.5V11.25H3V19.5ZM19.5 4.5H17.25V3.75C17.25 3.336 16.914 3 16.5 3C16.086 3 15.75 3.336 15.75 3.75V4.5H8.25V3.75C8.25 3.336 7.914 3 7.5 3C7.086 3 6.75 3.336 6.75 3.75V4.5H4.5C3.672 4.5 3 5.172 3 6V9.75H21V6C21 5.172 20.328 4.5 19.5 4.5ZM7.5 8.25C7.086 8.25 6.75 7.914 6.75 7.5C6.75 7.086 7.086 6.75 7.5 6.75C7.914 6.75 8.25 7.086 8.25 7.5C8.25 7.914 7.914 8.25 7.5 8.25ZM16.5 8.25C16.086 8.25 15.75 7.914 15.75 7.5C15.75 7.086 16.086 6.75 16.5 6.75C16.914 6.75 17.25 7.086 17.25 7.5C17.25 7.914 16.914 8.25 16.5 8.25Z",
	fill: "#546E7A"
}));
export default SvgEvents;
